import { CreditsPackage } from 'types/interfaces/CreditsPackage';

const OPTIMIZED_PRICES: Record<
  number,
  { initial_price_full: number; discount: number }
> = {
  40: { initial_price_full: 3.92, discount: 25 },
  80: { initial_price_full: 7.8, discount: 36 },
  200: { initial_price_full: 19.8, discount: 50 },
};

const getOptimizedPrice = (pack: CreditsPackage) => {
  const { credits_buy, initial_price_full, discount } = pack;

  return OPTIMIZED_PRICES[credits_buy] || { initial_price_full, discount };
};

const getOptimizedCreditPackages = (credit_packages: CreditsPackage[]) => {
  return credit_packages.map((pack: CreditsPackage) => {
    return {
      ...pack,
      ...getOptimizedPrice(pack),
    };
  });
};

export { getOptimizedCreditPackages };
